import Seo from "@/components/seo/Seo"

import ContactIntro from "@/components/sections/contact/ContactIntro"
import ContactForm from "@/components/sections/contact/ContactForm"

import SectionReveal from "@/components/common/SectionReveal"

export default function Contact() {
  return (
    <>
      <Seo
        title="Contact Zenia Stays"
        description="Get in touch with Zenia Stays for premium Airbnb and short-term rental management services."
        canonical="https://zeniastays.com/contact"
      />

      <ContactIntro />

      <SectionReveal>
        <ContactForm />
      </SectionReveal>

    </>
  )
}